import { render, staticRenderFns } from "./pickup-number.vue?vue&type=template&id=3788798a&"
import script from "./pickup-number.vue?vue&type=script&lang=js&"
export * from "./pickup-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports